export default {
  '未提交': 'unsubmitted',
  '待提交': 'SUBMITTED',
  '待审核': 'PENDING',
  '审核通过': 'VERIFIED',
  '未通过': 'REJECTED',
  '已取消': 'CANCELED',
  '已失效': 'DISABLED',
  '已提交': 'submitted',
  '未支付': 'unpaid',
  '已支付': 'paid',
  '已拒绝': 'refused',
  '男': 'MALE',
  '女': 'FEMALE',
  '已初审': 'FIRSTTRIAL',
}


// WEBPACK FOOTER //
// ./src/i18n/en-us/base/status.js